export default {"src":"/_next/static/media/upper-curved-polygon.5d71e3a3.svg","height":370,"width":603,"blurWidth":0,"blurHeight":0};